import React, {useState,useEffect} from "react";
import "./Album.css";
import img001 from "../Games/Puzzle/001.png";
import img002 from "../Games/Puzzle/002.png";
import img003 from "../Games/Puzzle/003.png";
import img004 from "../Games/Puzzle/004.png";
import img005 from "../Games/Puzzle/005.png";

export default  function AlbumS2() {
    const [English, setEnglish] = useState(true);
    const [CurrentImg, setCurrentImg] = useState(1);
    const [Imgs00, setImgs00] = useState("");
    const [Imgs01, setImgs01] = useState("");
    const [Imgs02, setImgs02] = useState("");
    const [Imgs10, setImgs10] = useState("");
    const [Imgs11, setImgs11] = useState("");
    const [Imgs12, setImgs12] = useState("");
    const [Imgs20, setImgs20] = useState("");
    const [Imgs21, setImgs21] = useState("");
    const [Imgs22, setImgs22] = useState("");
    const [Mid, setMid] = useState("Imgs0");
    const [Left, setLeft] = useState("Imgs1");
    const [Right, setRight] = useState("Imgs2");
    const [Move, setMove] = useState(false);

    var Img= [img001,img002,img003,img004,img005];
    
    const ChangeToChinese =()=>{
        setEnglish(false);
    }

    const ChangeToEnglish =()=>{
        setEnglish(true);
    }
    
    useEffect(()=>{
        
        //Mid
        setImgs00(img005)
        setImgs01(img001)
        setImgs02(img002)
        document.getElementById("Imgs0").style.marginLeft="-100%";
        document.getElementById("Imgs0").style.visibility="visible";
        //Left
        setImgs10(img004)
        setImgs11(img005)
        setImgs12(img001)
        document.getElementById("Imgs1").style.marginLeft="-200%";
        document.getElementById("Imgs1").style.visibility="hidden";
        //Right
        setImgs20(img001)
        setImgs21(img002)
        setImgs22(img003)
        document.getElementById("Imgs2").style.marginLeft="0%";
        document.getElementById("Imgs2").style.visibility="hidden";

        setTimeout(()=>{
            setMove(true);
        },800)
    },[]) 


    const MoveLeft =()=>{
        if (Move === true){
            var Mid_ = Mid;
            var Left_ = Left;
            var Right_ = Right;

            //Mid->Right
            document.getElementById(Mid).style.marginLeft="0%";
            document.getElementById(Mid).style.visibility="hidden";
            setRight(Mid_);

            //Left->Mid
            document.getElementById(Left).style.marginLeft="-100%";
            document.getElementById(Left).style.visibility="visible";
            setMid(Left_);

            //Right->Left
            document.getElementById(Right).style.marginLeft="-200%";
            document.getElementById(Right).style.visibility="hidden";
            ChangeLeft(Right, CurrentImg);
            setLeft(Right_);

            if (CurrentImg === 1){
                setCurrentImg(Img.length)
            }else{
                var CurrentImg_ = CurrentImg;
                setCurrentImg(CurrentImg_-1);
            }

            setMove(false);
            setTimeout(()=>{
                setMove(true);
            },800)

        }
    }

    const ChangeLeft =(Id, CurrentI)=>{
        if (Id === "Imgs0"){
            if(CurrentI-1 >0){
                setImgs02(Img[CurrentI-2])
            }else{
                setImgs02(Img[Img.length-1])
            }
            if(CurrentI-2 >0){
                setImgs01(Img[CurrentI-3])
            }else{
                setImgs01(Img[Img.length+(CurrentI-2)-1])
            }
            if(CurrentI-3 >0){
                setImgs00(Img[CurrentI-4])
            }else{
                setImgs00(Img[Img.length+(CurrentI-3)-1])
            }
        }else if (Id === "Imgs1"){
            if(CurrentI-1 >0){
                setImgs12(Img[CurrentI-2])
            }else{
                setImgs12(Img[Img.length-1])
            }
            if(CurrentI-2 >0){
                setImgs11(Img[CurrentI-3])
            }else{
                setImgs11(Img[Img.length+(CurrentI-2)-1])
            }
            if(CurrentI-3 >0){
                setImgs10(Img[CurrentI-4])
            }else{
                setImgs10(Img[Img.length+(CurrentI-3)-1])
            }
        }else if (Id === "Imgs2"){
            if(CurrentI-1 >0){
                setImgs22(Img[CurrentI-2])
            }else{
                setImgs22(Img[Img.length-1])
            }
            if(CurrentI-2 >0){
                setImgs21(Img[CurrentI-3])
            }else{
                setImgs21(Img[Img.length+(CurrentI-2)-1])
            }
            if(CurrentI-3 >0){
                setImgs20(Img[CurrentI-4])
            }else{
                setImgs20(Img[Img.length+(CurrentI-3)-1])
            }
        }
    }

    const MoveRight =()=>{
        if (Move === true){
            var Mid_ = Mid;
            var Left_ = Left;
            var Right_ = Right;

            //Mid->Left
            document.getElementById(Mid).style.marginLeft="-200%";
            document.getElementById(Mid).style.visibility="hidden";
            setLeft(Mid_);

            //Left->Right
            document.getElementById(Left).style.marginLeft="0%";
            document.getElementById(Left).style.visibility="hidden";
            ChangeRight(Left, CurrentImg);
            setRight(Left_);

            //Right->Mid
            document.getElementById(Right).style.marginLeft="-100%";
            document.getElementById(Right).style.visibility="visible";
            setMid(Right_);

            if (CurrentImg === Img.length){
                setCurrentImg(1)
            }else{
                var CurrentImg_ = CurrentImg;
                setCurrentImg(CurrentImg_+1);
            }

            setMove(false);
            setTimeout(()=>{
                setMove(true);
            },800)
        }
    }

    const ChangeRight =(Id, CurrentI)=>{
        if (Id === "Imgs0"){
            if(CurrentI >=Img.length){
                setImgs00(Img[CurrentI-Img.length])
            }else{
                setImgs00(Img[CurrentI])
            }
            if(CurrentI+1 >=Img.length){
                setImgs01(Img[CurrentI+1-Img.length])
            }else{
                setImgs01(Img[CurrentI+1])
            }
            if(CurrentI+2 >=Img.length){
                setImgs02(Img[CurrentI+2-Img.length])
            }else{
                setImgs02(Img[CurrentI+2])
            }
        }else if (Id === "Imgs1"){
            if(CurrentI >=Img.length){
                setImgs10(Img[CurrentI-Img.length])
            }else{
                setImgs10(Img[CurrentI])
            }
            if(CurrentI+1 >=Img.length){
                setImgs11(Img[CurrentI+1-Img.length])
            }else{
                setImgs11(Img[CurrentI+1])
            }
            if(CurrentI+2 >=Img.length){
                setImgs12(Img[CurrentI+2-Img.length])
            }else{
                setImgs12(Img[CurrentI+2])
            }
        }else if (Id === "Imgs2"){
            if(CurrentI >=Img.length){
                setImgs20(Img[CurrentI-Img.length])
            }else{
                setImgs20(Img[CurrentI])
            }
            if(CurrentI+1 >=Img.length){
                setImgs21(Img[CurrentI+1-Img.length])
            }else{
                setImgs21(Img[CurrentI+1])
            }
            if(CurrentI+2 >=Img.length){
                setImgs22(Img[CurrentI+2-Img.length])
            }else{
                setImgs22(Img[CurrentI+2])
            }
        }
    }

    return(
        <div>
        {English?(    
            <>
            <div className="AlbumS2">
                <h1> Album Style2</h1>
                <div className="AlbumS2-Language" onClick={ChangeToChinese}> <h3>中文</h3></div>

                <div  className="AlbumS2-Imgs" id="Imgs0">
                        <img src={Imgs00} alt=""/>
                        <img src={Imgs01} alt=""/>
                        <img src={Imgs02} alt=""/>
                </div>

                <div  className="AlbumS2-Imgs" id="Imgs1">
                        <img src={Imgs10} alt=""/>
                        <img src={Imgs11} alt=""/>
                        <img src={Imgs12} alt=""/>
                </div>

                <div  className="AlbumS2-Imgs" id="Imgs2">
                        <img src={Imgs20} alt=""/>
                        <img src={Imgs21} alt=""/>
                        <img src={Imgs22} alt=""/>
                </div>

                <button  className="ButtonS2-Left" onClick={MoveLeft}>{"<<"}</button>
                <button  className="ButtonS2-Right" onClick={MoveRight}>{">>"}</button>
            </div>
            </>
        ):(
            <>
            <div className="AlbumS2">
                <h1> 相册 样式2</h1>
                <div className="AlbumS2-Language" onClick={ChangeToEnglish}> <h3>English</h3></div>

                <div  className="AlbumS2-Imgs" id="Imgs0">
                        <img src={Imgs00} alt=""/>
                        <img src={Imgs01} alt=""/>
                        <img src={Imgs02} alt=""/>
                </div>

                <div  className="AlbumS2-Imgs" id="Imgs1">
                        <img src={Imgs10} alt=""/>
                        <img src={Imgs11} alt=""/>
                        <img src={Imgs12} alt=""/>
                </div>

                <div  className="AlbumS2-Imgs" id="Imgs2">
                        <img src={Imgs20} alt=""/>
                        <img src={Imgs21} alt=""/>
                        <img src={Imgs22} alt=""/>
                </div>

                <button  className="ButtonS2-Left" onClick={MoveLeft}>{"<<"}</button>
                <button  className="ButtonS2-Right" onClick={MoveRight}>{">>"}</button>
            </div>
            </>
        )}
        </div>
    )
}